exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload-wrapper .img-wrap[data-v-0bd4e99e]{position:relative;width:100%;height:180px;border:1px solid #c0ccda;border-radius:4px}.upload-wrapper .file-name[data-v-0bd4e99e]{width:100%;height:100%;text-align:center;display:flex;justify-content:center;align-items:center}.upload-wrapper .img-close[data-v-0bd4e99e]{position:absolute;top:-7px;right:-7px;padding:0}.upload-wrapper .upload-tips[data-v-0bd4e99e]{text-align:left!important;line-height:1;margin:0}.el-dragger__text[data-v-0bd4e99e]{padding:0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-0bd4e99e&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UploadItems/UploadFile.vue
// module id = 435
// module chunks = 0